/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddGroup from "../../Modals/addgroup";

import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
const ManageGroups = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [rows] = useState([
        { id: 1, name: "Products", active: true, number: "10" },
        { id: 2, name: "Stores", active: true, number: "4" },
        { id: 3, name: "Categories", active: false, number: "24" },
    ]);

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => setOpenModal(false);

    return (
        <>
            <div className="main_title">
                <h1>Manage Groups</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Groups
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* TOTAL STRUCTURES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            8
                            <p>Total Groups</p>
                        </h2>
                        <figure className="blue">
                            <AccountTreeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight info">
                        <span>Configured</span>
                        <small>across platform</small>
                    </div>
                </a>

                {/* ACTIVE STRUCTURES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            7
                            <p>Active Groups</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>70%</span>
                        <small>activation rate</small>
                    </div>
                </a>
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            18
                            <p>Total Tags</p>
                        </h2>
                        <figure className="blue">
                            <AccountTreeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight info">
                        <span>Configured</span>
                        <small>across platform</small>
                    </div>
                </a>





            </div>
            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search groups..."
                        />
                    </div>

                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
                            <AddIcon /> Add Group
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Group Name</TableCell>
                                <TableCell>No. of Tags</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow hover key={row.id}>

                                    {/* Sr No */}
                                    <TableCell>{index + 1}</TableCell>

                                    {/* Group Name */}
                                    <TableCell>
                                        <b>{row.name}</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>{row.number}</b>
                                    </TableCell>

                                    {/* Status Toggle */}
                                    <TableCell>
                                        <SwitchToggle checked={row.active} />
                                    </TableCell>

                                    {/* Actions */}
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton onClick={() => setOpenModal(true)}>
                                                <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                            </IconButton>

                                            <IconButton onClick={() => navigate("tags")}>
                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                            </IconButton>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <AddGroup
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default ManageGroups;
